import { get_user_details } from "@/router";
import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue";
import {
  is_organization_admin_role,
  normalize_organization_profile,
} from "@/utils/organization_profile";
import organization_members_access_methods from "./organization_members_access_methods";
import organization_members_context_methods from "./organization_members_context_methods";
import organization_members_form_methods from "./organization_members_form_methods";
import {
  member_is_active,
  member_is_pending,
} from "./organization_members_helpers";

export default {
  components: {
    HomeNavBar,
  },
  data: () => ({
    user_details: {},
    active_profile: null,
    organization_members: [],
    organization_permissions: [],
    search_query: "",
    members_table_instance: null,
    is_loading_members: false,
    is_creating_user: false,
    is_saving_access: false,
    is_inviting_member: false,
    is_bulk_adding_members: false,
    selected_member: null,
    saved_branding: null,
    member_access: {
      permission_ids: [],
    },
    member_access_errors: {},
    invite_user: {
      email: "",
      role: "user",
      invite_method: "email",
    },
    invite_errors: {},
    latest_invitation: null,
    new_user: {
      first_name: "",
      last_name: "",
      email: "",
      phone_number: "",
      role: "user",
    },
    new_user_errors: {},
    bulk_members: [],
    bulk_member_errors: {
      form: "",
      members: [],
    },
  }),
  computed: {
    organization() {
      return normalize_organization_profile(
        this.active_profile?.company || this.active_profile || {},
        this.user_details || {},
        this.saved_branding
      );
    },
    branding_style() {
      const style = {};
      if (this.organization.primary_color) {
        style["--primary-color"] = this.organization.primary_color;
        style["--accent-color"] = this.organization.primary_color;
      }
      if (this.organization.secondary_color) {
        style["--secondary-color"] = this.organization.secondary_color;
      }
      if (this.organization.tertiary_color) {
        style["--tertiary-color"] = this.organization.tertiary_color;
      }
      return style;
    },
    can_manage_members() {
      return is_organization_admin_role(this.user_details);
    },
    filtered_members() {
      const query = this.normalize_query(this.search_query);
      if (!query) return this.organization_members;
      return this.organization_members.filter((member) => this.user_matches_query(member, query));
    },
    member_stats() {
      return this.organization_members.reduce((stats, member) => {
        stats.total += 1;
        if (member_is_active(member)) stats.active += 1;
        if (member_is_pending(member)) stats.pending += 1;
        return stats;
      }, {
        total: 0,
        admins: 0,
        active: 0,
        pending: 0,
      });
    },
  },
  mounted() {
    this.user_details = get_user_details() || {};
    this.saved_branding = this.get_saved_branding();
  },
  beforeUnmount() {
    this.destroy_members_datatable();
  },
  watch: {
    search_query(value) {
      this.search_members_table(value);
    },
  },
  methods: {
    ...organization_members_context_methods,
    ...organization_members_form_methods,
    ...organization_members_access_methods,
  },
};
